export default __webpack_public_path__ + "media/images/app-icon-315252628cd2eb25ebeab9453fe04241.png";